import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, take } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

//Estilo que muestra un rectangulo que parece boton
const style = {
    display: "inline-block",
    padding: "6px 12px",
    marginBottom: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    border: "1px solid transparent",
    borderRadius: "4px",
    color: "#333",
    backgroundColor: "rgba(100,100,100, 0.1)",
    borderColor: "#ccc"
};

/**Dibuja un punto de la ruta */
class PuntoRuta extends React.PureComponent<{ value: models.PuntoEnrutamiento }> {
    render() {
        const x = this.props.value;
        return (
            <span>
                {<i className={fa("arrow-right")} />}
                {<i className={x.EsTrasbordo ? fa("cubes", "fw") : fa("truck", "fw", "flip-horizontal")} />}
                <div style={style}>
                    <span>


                        <span style={{ fontFamily: "monospace", fontWeight: "bold" }}>
                            {x.NombreSucursalOrigen}, {x.NombreSucursalDestino}
                        </span>

                    </span>
                    <br />
                    <span>
                        <span style={{ fontStyle: "italic" }}>
                            {x.NombreRuta}
                        </span>
                        {" "}
                        {
                            x.EsTrasbordo &&
                            <span className={"label label-" + (x.EsTrasbordo ? "warning" : "info")}>
                                Trasbordo
                            </span>
                        }
                    </span>
                </div>
            </span>
        )
    }
}

class EnDestino extends React.PureComponent {
    render() {
        return (
            <div style={{
                ...style,
                background: "rgba(20,255,40, 0.3)",
                borderColor: "rgba(5,100,10, 0.5)",

                fontFamily: "sans-serif"
            }}>
                <h4>
                    <i className={fa("check")} />
                    En destino
                </h4>
            </div>
        )
    }
}

class CargaDescarga extends React.PureComponent<{ tipo: "carga" | "descarga" }> {
    render() {
        const tipo = this.props.tipo;
        return (
            <span style={{
                fontSize: "12px",
                width: "85px",
                border: "1px solid transparent",
                borderRadius: "4px",
                color: "#333",
                padding: "6px 12px",
                display: "inline-block",
                backgroundColor: (tipo == "carga") ? "rgba(40,255,60, 0.2)" : "rgba(255,60,40, 0.2)",
                borderColor: "rgba(0,0,0,0.2)",
                textAlign: "center"
            }} >

                {(tipo == "carga") ? "Carga" : "Descarga"}
            </span>
        )
    }
}

/**Dibuja una solucion de ruta */
class SolucionRuta extends React.PureComponent<{ value: models.SolucionEnrutamiento, idRutaOrigen: number | undefined }> {
    render() {
        return (
            <div>
                {this.props.value.Puntos.length == 0 ?
                    <span>
                        <span>
                            <CargaDescarga tipo="descarga" />
                            <EnDestino />
                        </span>
                    </span> :
                    <span>
                        {
                            this.props.idRutaOrigen != null &&
                            <CargaDescarga tipo={this.props.idRutaOrigen == this.props.value.Puntos[0].IdRuta ? "carga" : "descarga"} />
                        }
                        {this.props.value.Puntos.map((x, i) => <PuntoRuta key={i} value={x} />)}
                    </span>
                }
                <hr />
            </div>
        )
    }
}

class SolucionesRutaNoRx extends React.PureComponent<{ value: models.SolucionEnrutamiento[] | null, idRutaOrigen: number | undefined }> {
    render() {
        const x = this.props.value;
        if (x == null) return null;
        return (
            <div>
                <label>Rutas posibles: {x.length}</label>
                {take(x, 100).map((x, i) => <SolucionRuta key={i} value={x} idRutaOrigen={this.props.idRutaOrigen} />)}
            </div>
        )
    }
}

export const SolucionesRuta = componentToRx(SolucionesRutaNoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/enrutamiento/solucionesRuta.tsx